import * as Yup from "yup";

export const createUserValidations = (title, roleId) => {
  return Yup.object().shape({
    officeLocationId: Yup.string().required("This field is required"),
    firstName: Yup.string().required("This field is required"),
    lastName: Yup.string().required("This field is required"),
    employeeId:
      roleId === 1 ? Yup.string().required("This field is required") : "",
    email: Yup.string()
      .email("Invalid Email")
      .required("This field is required"),
    contactNumber: Yup.string()
      .matches(/^\d+$/, "Must be only numbers")
      .length(10, "Must be exactly 10 digits")
      .required("This field is required"),
    password:
      title === "Add" ? Yup.string().required("This field is required") : "",
    // designation: Yup.string().required("This field is required"),
    permission:
      roleId === 1
        ? Yup.array()
            .min(1, "At least one permission must be selected")
            .required("Permission is required")
        : "",
  });
};

export const editUserValidations = () => {
  return Yup.object().shape({
    officeLocationId: Yup.string().required("This field is required"),
    firstName: Yup.string().required("This field is required"),
    lastName: Yup.string().required("This field is required"),
    employeeId: Yup.string().required("This field is required"),
    email: Yup.string()
      .email("Invalid Email")
      .required("This field is required"),
    contactNumber: Yup.string()
      .matches(/^\d+$/, "Must be only numbers")
      .length(10, "Must be exactly 10 digits")
      .required("This field is required"),
    // designation: Yup.string().required("This field is required"),
    permission: Yup.array()
      .min(1, "At least one permission must be selected")
      .required("Permission is required"),
  });
};

export const vendorValidationSchema = () => {
  return Yup.object().shape({
    vendorName: Yup.string().required("This field is required"),
    vendorLocationId: Yup.string().required("This field is required"),
    vendorEmail: Yup.string()
      .email("Invalid Email")
      .required("This field is required"),
    vendorPhone: Yup.string()
      .length(10, "Must be exactly 10 digits")
      .required("This field is required"),
  });
};
